import React, {useMemo} from 'react';
import { ApiSelect } from 'react-admin-base-bootstrap';
import Languages from '../data/languages.json';

export function MapSelect(props) {
    const { value, onChange, staticOptions, isMulti } = props;

    return <ApiSelect
        {...props}
        staticOptions={Object.entries(staticOptions).map(a => ({ id: a[0], name: a[1] }))}
        value={value && (isMulti ? value.map(a => ({ id: a, name: staticOptions[a] })) : { id: value, name: staticOptions[value] })}
        onChange={a => onChange(a && (isMulti ? a.map(b => b.id) : a.id))}
    />;
}

export function LanguageSelect(props) {
    const { value } = props;

    const languages = useMemo(() => Object.entries(Languages)
        .reduce((a,b) => ({ ...a, [b[0]]: b[1].name + ' (' + b[1].nativeName + ')' }), {}), []);

    return <MapSelect
        {...props}
        staticOptions={languages}
    />;
}
